import { render, staticRenderFns } from "./ReportsPharmacy.vue?vue&type=template&id=1a72f5b0&scoped=true"
import script from "./ReportsPharmacy.vue?vue&type=script&lang=js"
export * from "./ReportsPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72f5b0",
  null
  
)

export default component.exports